const FOOT_LINKS = [
  { label: '在追事件', href: '#watch' },
  { label: '最新进展', href: '#feed' },
  { label: '当事人回应', href: '#response' },
  { label: '话题墙', href: '#topics' },
  { label: '反转观察', href: '#reversal' },
  { label: '常见问题', href: '#faq' },
];

export default function Footer() {
  return (
    <footer className="bg-background-100/80">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-900 text-background-50">
                <i className="ri-eye-line text-sm" />
              </span>
              <span className="font-heading text-base font-bold text-foreground-950">在线黑料</span>
            </div>
            <p className="mt-4 text-xs leading-relaxed text-foreground-600">
              持续跟进在线黑料的后续进展、当事人回应与跟踪报道，关注反转可能，长期回看不迷路。
            </p>
          </div>

          <nav className="grid grid-cols-2 gap-x-10 gap-y-2 sm:grid-cols-3">
            {FOOT_LINKS.map((item) => (
              <a key={item.href} href={item.href} className="whitespace-nowrap text-sm text-foreground-700 hover:text-foreground-950">
                {item.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-10 rounded-lg border border-background-200 bg-background-50 p-5">
          <p className="font-label text-xs font-semibold text-foreground-800">内容说明</p>
          <p className="mt-2 text-xs leading-relaxed text-foreground-600">
            本频道为公开信息的整理与跟踪页面，非新闻采编机构。所有内容仅作信息参考，观点与措辞不代表对事件当事人作出事实性结论；涉及传闻与指控均保留待核验状态。如涉权利问题，可通过频道反馈入口联系处理。
          </p>
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} 在线黑料 · 持续跟进频道</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-time-line" />
            本站信息持续整理更新，请以最新跟踪报道为准
          </p>
        </div>
      </div>
    </footer>
  );
}